import React, { useEffect, useState } from 'react';
import prodImporter from '@boschebike/ebds-js/dist-esm/helpers/web-generic/feedback.import.prod.js';

/**
 * @typedef {import('./WebGenericFeedbackCTA.d.ts').WebGenericFeedbackCTAProps} WebGenericFeedbackCTAProps
 */
/**
 * @param {WebGenericFeedbackCTAProps} props
 */
const WebGenericFeedbackCTA = ({
  customImporter = prodImporter,
  onDispatchModal
}) => {
  const [ctaNode, setCtaNode] = useState(null);
  useEffect(() => {
    customImporter();
  }, []);
  useEffect(() => {
    if (!ctaNode) {
      return () => {};
    }
    const listener = () => {
      onDispatchModal();
    };
    ctaNode.addEventListener('ebweb-feedback-cta-click', listener);
    return () => {
      ctaNode.removeEventListener('ebweb-feedback-cta-click', listener);
    };
  }, [ctaNode]);
  return /*#__PURE__*/React.createElement("ebweb-feedback-cta", {
    ref: setCtaNode
  });
};
export default WebGenericFeedbackCTA;